import {
  FETCH_LOAD_ALL_DOC_FOR_PROJECT_ASS_REQUEST,
  FETCH_LOAD_ALL_DOC_FOR_PROJECT_ASS_SUCCESS,
  FETCH_LOAD_ALL_DOC_FOR_PROJECT_ASS_FALUIRE,
} from './loadAllDocForProjectAssociationTypes'

const initialState = {
  loading: false,
  allDocListForProjAss: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_LOAD_ALL_DOC_FOR_PROJECT_ASS_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_LOAD_ALL_DOC_FOR_PROJECT_ASS_SUCCESS : return {
      ...state,
      allDocListForProjAss: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_LOAD_ALL_DOC_FOR_PROJECT_ASS_FALUIRE : return {
      ...state,
      loading: false,
      allDocListForProjAss: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
